var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_Search",
    width: 24,
    height: 24,
    "data-name": "Icon - Search",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-4{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_Search-2",
    fill: "none",
    "data-name": "Icon - Search",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_1073",
    stroke: "#afafaf",
    strokeWidth: "2px",
    "data-name": "Ellipse 1073"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    className: "prefix__cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Intersection_1",
    "data-name": "Intersection 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.6 6.726L0 2.122 2.121 0l4.6 4.6A1.5 1.5 0 0 1 4.6 6.726z",
    className: "prefix__cls-4",
    transform: "translate(8.831 8.83)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afafaf",
    d: "M5.665 7.165c-.384 0-.768-.146-1.06-.439L0 2.122 2.121 0l4.605 4.605c.586.585.586 1.535 0 2.121-.293.293-.677.439-1.06.439z",
    transform: "translate(8.831 8.83)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.9a0f0c308b2df4f06673cac557f95344.svg";
export { ForwardRef as ReactComponent };